import { request } from '@/utils/request';

// 组织树
export const getOrgTree = params => request('/system/org/tree', 'get', params);

// 获取用户菜单权限
export const getMenuForCurrentUser = params =>
  request('/system/profile/getMenuForCurrentUser', 'get', params);

// 用户列表
export const getUserList = params => request('/system/user/page', 'get', params);

// 用户详情
export const getUserDetail = params => request(`/system/user/${params.id}`, 'get');

// 角色列表选择
export const getRoleList = params => request('/system/role/list', 'get', params);

// 岗位列表下选择
export const getPostList = params => request('/system/post/list', 'get', params);

// 图片上传
export const uploadApi = params => request(`/system/profile/userAvatar`, 'post', params);

// 编辑提交
export const editUser = params => request(`/system/user/update`, 'post', params);

// 新增提交
export const addUser = params => request(`/system/user/create`, 'post', params);

// 删除
export const deleteUser = params => request(`/system/user/delete`, 'post', params);

// 修改密码
export const resetPwd = params => request(`/system/user/update/password`, 'post', params);

// 启用/禁用
export const changeStatus = params => request(`/system/user/update/status`, 'post', params);

//  用户导入
export const importFile = params => request(`/system/user/batch/importFile`, 'post', params);

//  用户导出
export const exportUserFile = params => request(`/system/user/batch/exportFile`, 'post', params);
